import React from 'react';
import './index.css';
import { CloseIcon } from '../../icons';
import { ModalBase } from '../../Modals';

const ConfirmDialog = ({ onClose, onConfirm, title, subtitle, ...props }) => {

    return (
        <ModalBase onClose={onClose}>
            <div className="confirm-dialog" {...props}>
                <div className="confirm-action-row">
                    <CloseIcon stroke="#282424" size={15} onClick={() => onClose && onClose()} />
                </div>
                <div className="confirm-title">{title}</div>
                <div className="confirm-subtitle">{subtitle}</div>
                <div className="confirm-footer">
                    <div className="confirm-button cancel" onClick={() => onClose && onClose()}>Cancel</div>
                    <div className="confirm-button confirm" onClick={() => onConfirm && onConfirm()}>Yes</div>
                </div>
            </div>
        </ModalBase>
    );
};

export default ConfirmDialog;
